export const PROMO_TYPES = {
  BEST_VALUE: "bestValue",
  PEACE_OF_MIND: "peaceOfMind"
};
